export const hasSubOrgAccess = (user, subOrgId) => {
  if (!user || !Array.isArray(user.sub_org_ids)) return false
  return user.sub_org_ids.includes(subOrgId)
}

